import {
  GzFormFieldWebComponent,
  GzSingleSelectComplexWebComponent,
  GzTextareaWebComponent,
  GzTextWebComponent,
  GzTitleWebComponent,
} from 'apps/webcomponents/src/index.ui';
import { BaseWebComponentView } from '../../../../framework/BaseWebComponentView';
import { FormGroup } from '../../../../ui/gzForm/formGroup/form-group';
import { IntegrationActionContext } from '../../../integrationsMarketplaceGridInstalled/types';
import { getIntegrationStrings } from '../integrationStrings';
import { RequiredValidator } from 'apps/webcomponents/src/ui/gzForm/validators/required.validator';
import { MaxLengthValidator } from 'apps/webcomponents/src/ui/gzForm/validators/max-length.validator';
import { RegexValidator } from 'apps/webcomponents/src/ui/gzForm/validators/regex.validator';
import { RemoteValidator } from 'apps/webcomponents/src/ui/gzForm/validators/remote.validator';
import { getIntegrationData, INTEGRATION_TYPES } from '../../../common/constants';
import { toggleVisibility } from 'apps/webcomponents/src/utils/htmlElement.utils';
import { API_TYPE_COMPANIES_FOR_CONTAINER_IMAGE_SCANNER_INTEGRATIONS } from 'apps/webcomponents/src/webcomponents.constants';
import { GetItemsResponse } from 'apps/webcomponents/src/ui/gzSingleSelectComplex/types';
import { IntegrationData } from '../../types';
import { ContainerImageScannerSpecifics } from '../types';
import { GzInputWebComponent } from 'apps/webcomponents/src/ui/gzInput/component/GzInputWebComponent';

export class IntegrationContainerImageScannerView extends BaseWebComponentView {
  public context: IntegrationActionContext;
  public formGroup: FormGroup;
  public dom: {
    $integrationFormWrapper: HTMLElement;

    $integrationDescription: GzTextWebComponent;

    $configurationSectionTitle: GzTitleWebComponent;
    $companyFormField: GzFormFieldWebComponent<GzSingleSelectComplexWebComponent, string | number>;
    $integrationNameFormField: GzFormFieldWebComponent;

    $checkRequirementsHeader: GzTitleWebComponent;
    $checkRequirementsDescription: GzTextWebComponent;

    $connectScannerStep1: GzTextWebComponent;
    $connectScannerStep2: GzTextWebComponent;
    $connectScannerStep3: GzTextWebComponent;
    $connectScannerStep4: GzTextWebComponent;
    $connectScannerStep5: GzTextWebComponent;
    $connectScannerStep6: GzTextWebComponent;
    $connectScannerStep7: GzTextWebComponent;
    $connectScannerHeader: GzTitleWebComponent;
    $connectScannerFooter: GzTextWebComponent;

    $connectScannerStep1Input: GzTextareaWebComponent;
    $connectScannerStep2Input: GzInputWebComponent;
    $connectScannerStep3Input: GzInputWebComponent;
    $connectScannerStep4Input: GzTextareaWebComponent;
    $connectScannerStep5Input: GzInputWebComponent;
    $connectScannerStep6Input: GzTextareaWebComponent;
    $connectScannerStep7Input: GzInputWebComponent;

    $connectScannerStep1Text: GzTextWebComponent;

    $downloadScannerTitle: GzTitleWebComponent;
    $authScannerTitle: GzTitleWebComponent;
  };

  getDomElements() {
    this.dom = {
      $integrationFormWrapper: this.shadow.querySelector('#details-section'),

      $integrationDescription: this.shadow.querySelector('#integration-description'),

      $configurationSectionTitle: this.shadow.querySelector('#configuration-section-title'),
      $companyFormField: this.shadow.querySelector('#integration-company-form-field'),
      $integrationNameFormField: this.shadow.querySelector('#integration-name-form-field'),

      $checkRequirementsHeader: this.shadow.querySelector('#check-requirements-header'),
      $checkRequirementsDescription: this.shadow.querySelector('#check-requirements-description'),

      $connectScannerHeader: this.shadow.querySelector('#connect-scanner-header'),
      $connectScannerStep1: this.shadow.querySelector('#connect-scanner-step-1'),
      $connectScannerStep2: this.shadow.querySelector('#connect-scanner-step-2'),
      $connectScannerStep3: this.shadow.querySelector('#connect-scanner-step-3'),
      $connectScannerStep4: this.shadow.querySelector('#connect-scanner-step-4'),
      $connectScannerStep5: this.shadow.querySelector('#connect-scanner-step-5'),
      $connectScannerStep6: this.shadow.querySelector('#connect-scanner-step-6'),
      $connectScannerStep7: this.shadow.querySelector('#connect-scanner-step-7'),
      $connectScannerFooter: this.shadow.querySelector('#connect-scanner-footer'),

      $connectScannerStep1Input: this.shadow.querySelector('#connect-scanner-step-1-input'),
      $connectScannerStep2Input: this.shadow.querySelector('#connect-scanner-step-2-input'),
      $connectScannerStep3Input: this.shadow.querySelector('#connect-scanner-step-3-input'),
      $connectScannerStep4Input: this.shadow.querySelector('#connect-scanner-step-4-input'),
      $connectScannerStep5Input: this.shadow.querySelector('#connect-scanner-step-5-input'),
      $connectScannerStep6Input: this.shadow.querySelector('#connect-scanner-step-6-input'),
      $connectScannerStep7Input: this.shadow.querySelector('#connect-scanner-step-7-input'),

      $connectScannerStep1Text: this.shadow.querySelector('#connect-scanner-step-1-text'),

      $downloadScannerTitle: this.shadow.querySelector('#download-scanner-title'),
      $authScannerTitle: this.shadow.querySelector('#auth-scanner-title'),
    };

    this.getTranslations();
    this.setTranslatedStrings();
    this.setInputValues();
  }

  getTranslations() {
    this.translations = getIntegrationStrings();
    return this.translations;
  }

  async buildSuccessView(viewData: any): Promise<void> {
    this.dom.$integrationFormWrapper.dispatchEvent(
      new CustomEvent('cnappIntegrationFormLoaded', {
        bubbles: true,
        composed: true,
      })
    );

    this.setCompanyDropdown(viewData);
    this.createFormGroup(viewData);
  }

  setTranslatedStrings(): void {
    this.dom.$integrationDescription.innerText = this.translations.integrationDescription;

    this.dom.$configurationSectionTitle.innerText = this.translations.configurationTitle;
    this.dom.$companyFormField.label = this.translations.companyFormFieldLabel;
    if (this.dom.$companyFormField.Input) {
      this.dom.$companyFormField.Input.placeholder = this.translations.companyFormFieldPlaceholder;
      this.dom.$companyFormField.Input.searchPlaceholderString = this.translations.companyFormFieldSearchPlaceholder;
      this.dom.$companyFormField.Input.noSearchResultsString = this.translations.companyFormFieldNoSearchResults;
    }
    this.dom.$integrationNameFormField.label = this.translations.integrationNameFormFieldLabel;

    this.dom.$checkRequirementsHeader.innerText = this.translations.checkRequirementsHeader;
    this.dom.$checkRequirementsDescription.innerHTML = this.translations.checkRequirementsDescription;

    // Connect Scanner strings
    this.dom.$connectScannerHeader.innerText = this.translations.connectScannerHeader;
    this.dom.$connectScannerStep1.innerText = this.translations.connectScannerStep1;
    this.dom.$connectScannerStep2.innerText = this.translations.connectScannerStep2;
    this.dom.$connectScannerStep3.innerText = this.translations.connectScannerStep3;
    this.dom.$connectScannerStep4.innerText = this.translations.connectScannerStep4;
    this.dom.$connectScannerStep5.innerText = this.translations.connectScannerStep5;
    this.dom.$connectScannerStep6.innerText = this.translations.connectScannerStep6;
    this.dom.$connectScannerStep7.innerText = this.translations.connectScannerStep7;

    this.dom.$connectScannerStep1Text.innerHTML = `
      ${this.translations.connectScannerStep1Text}
      <gz-link
        type="underline"
        id="connect-scanner-binary-link"
        href="https://download.bitdefender.com/business/tools/bcst-cli/bcst-cli_Linux_x86_64.tar.gz"
        target="_blank"
      >
        <span>${this.translations.connectScannerBinaryLink}</span>
      </gz-link>
    `;

    this.dom.$connectScannerFooter.innerHTML = `
      ${this.translations.connectScannerFooter}
      <gz-link
        type="underline"
        id="connect-scanner-kb-link"
        href="${getIntegrationData(INTEGRATION_TYPES.INTEGRATION_TYPE_CONTAINER_IMAGE_SCANNER).linkLabel}"
        target="_blank"
      >
        <span>${this.translations.connectScannerKBLink}</span>
      </gz-link>
    `;

    this.dom.$downloadScannerTitle.innerText = this.translations.downloadScannerTitle;
    this.dom.$authScannerTitle.innerText = this.translations.authScannerTitle;
  }

  public createFormGroup(viewData: any): void {
    this.formGroup = new FormGroup(this.getFormGroupItems());
    this.setFormFieldsValidators(viewData);
  }

  public getFormGroup(): FormGroup {
    return this.formGroup;
  }

  public setIntegrationData(integration: IntegrationData<ContainerImageScannerSpecifics>) {
    this.dom.$companyFormField.Input.setFormValue(integration.company.id);
    this.dom.$integrationNameFormField.Input.setFormValue(integration.name);
  }

  private setInputValues(): void {
    this.dom.$connectScannerStep1Input.value =
      'wget https://download.bitdefender.com/business/tools/bcst-cli/bcst-cli_Linux_x86_64.tar.gz';
    this.dom.$connectScannerStep2Input.value = 'tar -xzf bcst-cli_Linux_x86_64.tar.gz';
    this.dom.$connectScannerStep3Input.value = './bcst-cli --help';
    this.dom.$connectScannerStep4Input.value = ''; // This will be set dynamically based on the server URL
    this.dom.$connectScannerStep5Input.value = 'bcst-cli config server set <url>';
    this.dom.$connectScannerStep6Input.value = ''; // This will be set dynamically based on the access token
    this.dom.$connectScannerStep7Input.value = 'bcst-cli config token set <access-token>';
  }

  private setFormFieldsValidators(viewData: any): void {
    this.setIntegrationNameValidator(viewData.integrationId);
    this.setCompanyValidators();
  }

  private setCompanyValidators(): void {
    this.dom.$companyFormField.Validators = [RequiredValidator(this.commonStrings.requiredField)];
  }

  private setIntegrationNameValidator(integrationId: string): void {
    this.dom.$integrationNameFormField.Validators = [
      RequiredValidator(this.commonStrings.requiredField),
      MaxLengthValidator(128, this.translations.integrationNameMaxLength),
      RegexValidator(
        /^[^\s](.)*$/, // ensures no leading whitespace
        this.translations.invalidIntegrationName
      ),
      RemoteValidator(
        (value: string) =>
          this.dependencies.api.clients.IntegrationsMarketplace.CheckIntegrationNameIsUnique(
            value,
            this.dom.$companyFormField?.value || this.dependencies.getActiveCompany()?.companyId,
            integrationId,
            INTEGRATION_TYPES.INTEGRATION_TYPE_CONTAINER_IMAGE_SCANNER
          ),
        (response: { success: boolean }) => response.success,
        this.dependencies.translateFn('Integration name already exists in the company.'),
        this.dependencies.translateFn('A communication error has occurred. Please enter the integration name again.')
      ),
    ];
  }

  private setCompanyDropdown(viewData: any): void {
    if (this.dependencies.permissions.canHaveChildCompanies) {
      toggleVisibility(this.dom.$companyFormField, true);
      this.dom.$companyFormField.removeAttribute('disabled');

      this.dom.$companyFormField.Input.setApiType(API_TYPE_COMPANIES_FOR_CONTAINER_IMAGE_SCANNER_INTEGRATIONS);

      const companyData: GetItemsResponse = {
        items: [],
        totalItemsCount: 0,
      };

      let edit = false;
      if (viewData.company) {
        companyData.items.push({
          label: viewData.company.name,
          value: viewData.company?.id,
        });
        companyData.totalItemsCount = 1;
        edit = true;
      }

      this.dom.$companyFormField.Input.updateComplete.then(() => {
        // set preventBackendCall flag in context of Edit because there is no need to load companies from db
        this.dom.$companyFormField.Input.controller.setFilterOptions(companyData, edit).then().catch();
      });
      if (edit) {
        this.dom.$companyFormField.setAttribute('disabled', '');
      }
    } else {
      toggleVisibility(this.dom.$companyFormField, false);
      this.dom.$companyFormField.setAttribute('disabled', '');
    }
  }

  private getFormGroupItems() {
    const formGroupItems: {} = {};

    formGroupItems['integrationName'] = this.dom.$integrationNameFormField;
    formGroupItems['company'] = this.dom.$companyFormField;

    return formGroupItems;
  }
}
